module.exports = __webpack_public_path__ + "static/img/a.f943e93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/a.png
// module id = KL9Q
// module chunks = 0